export interface ZakliknuteFieldyRequest {
    klientSluzbaId: number;
    filterFieldList?: string[]; // ak je vyplnene, len tieto fieldy chceme
}

export interface ZakliknuteFieldyResponse {
    fieldAndCountList: FieldAndCount[];
}

export interface FieldAndCount {
    field: string; // nazov atributu
    count: number; // kolkokrat bol atribut zakliknuty
}

export interface MergeKlientRequest {
    klientToRemoveId: number;
    klientToStayId: number;
}

export interface GetMaxTCisloIAResponse {
    tCisloIA: number | null;
}

// bud vyhladavame cez docTemplateRowId (id zaznamu) alebo cez templateId (kod zaznamu)
export interface TlacitDokumentRequest {
    docTemplateRowId?: number,
    templateId?: string,
    klientSluzbaId: number,
    datumDokumentu: Date;
    cisloZmluvy: string;
}

export enum TypZakazu {
    bezZakazu,
    kratkodoby,
    dlhodoby,
    trvaly
}
